import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] mx-4 md:mx-10 rounded-t-3xl mt-0">
      <div className="px-8 md:px-16 pt-20 pb-10">
        {/* Upper Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 pb-16 border-b border-white/10">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <div className="w-[120px] h-[120px] flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/65c3d545-bf67-4e3a-abd4-07a3626b250e.png"
                  alt="AlphaOps AI"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <p className="text-[#707070] text-sm leading-relaxed mb-8 max-w-xs">
              Smarter systems. Stronger margins. We build operational infrastructure that turns missed opportunities into measurable revenue.
            </p>
            <div className="flex items-center gap-5">
              <a href="https://linkedin.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center text-[#707070] hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="https://twitter.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center text-[#707070] hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://youtube.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center text-[#707070] hover:text-white transition-colors cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-[#707070] text-xs uppercase tracking-widest mb-6">Quick Links</p>
            <ul className="flex flex-col gap-4">
              {[
                { label: 'Home', to: '/' },
                { label: 'Industries', to: '/industries' },
                { label: 'What We Deliver', to: '/#deliver' },
                { label: 'Why AlphaOps AI', to: '/#why' },
              ].map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-white text-sm hover:text-[#38C6F5] transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[#707070] text-xs uppercase tracking-widest mb-6">Get in Touch</p>
            <div className="flex flex-col gap-3 mb-8">
              <a href="tel:+18005550199" className="text-white text-sm hover:text-[#38C6F5] transition-colors cursor-pointer">
                +1 (800) 555-0199
              </a>
              <a href="mailto:hello@alphaopsai.com" className="text-white text-sm hover:text-[#38C6F5] transition-colors cursor-pointer">
                hello@alphaopsai.com
              </a>
            </div>
            <p className="text-[#707070] text-xs uppercase tracking-widest mb-3">Office</p>
            <p className="text-[#707070] text-sm leading-relaxed">
              340 Pine Street, Suite 800<br />
              San Francisco, CA 94104
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#707070] text-xs hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-[#707070] text-xs hover:text-white transition-colors cursor-pointer">Terms of Service</a>
          </div>
          <p className="text-[#707070] text-xs">© 2026 AlphaOps AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
